import {  SlotGameType1_3 } from "../SlotGameType1_3";
export class BurningFruits100_3 extends SlotGameType1_3{}